<template>
  <div>
    <div
      class=" category-btn py-1 d-flex justify-content-between align-items-center hover-cursor-pointer focus-outline-yellow"
      @click="isActive = !isActive"
      @keyup.enter="isActive = !isActive"
      role="button"
      tabindex="0"
      :aria-label="category.name"
      :aria-owns="'category-grid_' + category.id"
      :aria-expanded="isActive">
      <span class="category-title is-size-5">{{ category.name }}</span>
      <span class="icon">
        <i class="fa fa-angle-right" :class="{ openIcon: isActive, closeIcon: !isActive}" aria-hidden="true"></i>
      </span>
    </div>
    <transition name="fade">
      <div class="py-2 px-1 focus-outline-yellow" v-show="isActive" role="grid" :aria-rowcount="category.features.length"  :id="'category-grid_' + category.id" tabindex="-1" :aria-label="category.name">
        <cmps-checkbox
          v-for="feature in category.features"
          :key="feature.id" :id="feature.id"
          :name="feature.name"
          :active="isActive"
          :description="feature.description">
        </cmps-checkbox>
      </div>
    </transition>
  </div>
</template>

<script>
import Checkbox from './Checkbox.vue'
  export default {
    props: ['category'],
    components: {
      cmpsCheckbox: Checkbox
    },
    data() {
      return {
        isActive: false
      }
    },
    computed: {
      tooltip() { return this.$store.state.main.tooltip }
    },
    watch: {
      /*
        important that closeMenu is a KEYDOWN event, i.e. opposite the KEYUP event in checkbox.vue
        tooltip in checkbox.vue AND dropdown menu in this component allow keyboard users to close widgets with "escape key: 27"
        using the escape key to close dropdown menu and tooltip widgets are guidelines of WAI-ARIA Authoring Practices 1.1
        https://www.w3.org/TR/wai-aria-practices
      */
      'isActive' (value) {
        if (value) {
          window.addEventListener('keydown', this.closeMenu)
          setTimeout(() => document.querySelector('#category-grid_' + this.category.id).focus()) // need to push later on stack for focus to work
        } else {
          window.removeEventListener('keydown', this.closeMenu)
        }
      }
    },
    methods: {
      closeMenu(e) {
        if (e.keyCode === 27 && !this.tooltip.display) {
          this.isActive = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .category-btn {
    width: 100%;
    background-color: transparent;
    color: #fff;
    border: none;
    &:hover, &:active, &:focus {
      color: #fff;
      background-color: #7c6493;
    }
    span.category-title {
      font-weight: 400;
      text-align: left;
    }
  }
  .openIcon {
    -webkit-transform: rotateZ(90deg);
    -moz-transform: rotateZ(90deg);
    -ms-transform: rotateZ(90deg);
    transform: rotateZ(90deg);
    -webkit-transition: transform .5s;
    -moz-transition: transform .5s;
    -ms-transition: transform .5s;
    transition: transform .5s;
  }
  .closeIcon {
    -webkit-transform: rotateZ(0deg);
    -moz-transform: rotateZ(0deg);
    -ms-transform: rotateZ(0deg);
    transform: rotateZ(0deg);
    -webkit-transition: transform .5s;
    -moz-transition: transform .5s;
    -ms-transition: transform .5s;
    transition: transform .5s;
  }
</style>
